export default {
    AgentOnHoldEvent: "Agent On Hold Event",
    AudioVideoWillBeEnabledAfter: "Your video and audio will be enabled after <b></b> seconds...",
    EnableAudioVideo: "Enable Video and Audio",
}